import { Button, ICONS, Icon } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { format, parseISO } from 'date-fns';
import React, { useState } from 'react';
import styles from './Documents.module.scss';

const cx = classNames.bind(styles);

export interface Document {
  id: string;
  publishedDate: string;
  title: string;
  url: string;
}

interface DocumentsProps {
  list: Document[];
  alwaysVisibleCount?: number;
}

const Documents = ({ list, alwaysVisibleCount = 2 }: DocumentsProps): React.ReactElement | null => {
  const [expanded, setExpanded] = useState(false);

  if (list.length === 0) {
    return null;
  }

  const additionalCount = list.length - alwaysVisibleCount;

  const renderDocs = (list: Document[], start = 1) => (
    <ol className={cx('list')} start={start}>
      {list.map((item) => (
        <li key={item.id}>
          <div>
            <a href={item.url} className={styles.documentTitle} target="_blank" rel="noopener noreferrer">
              {item.title}
            </a>
          </div>
          <div className={cx('document-source')}>
            CreditSights &bull; {format(parseISO(item.publishedDate), 'dd MMM yyyy')}
          </div>
        </li>
      ))}
    </ol>
  );

  return (
    <div>
      <div className={cx('title')}>Source(s):</div>
      {renderDocs(list.slice(0, alwaysVisibleCount))}
      {additionalCount > 0 ? (
        <div className={cx('expand', { expand_opened: expanded })}>
          <div>
            <Button className={cx('expandBtn')} onClick={() => setExpanded(!expanded)}>
              <Icon name={ICONS.CaretRight} />
            </Button>
          </div>
          <div>
            + {additionalCount} additional source{additionalCount > 1 ? 's' : ''}
          </div>
        </div>
      ) : null}
      {expanded ? renderDocs(list.slice(alwaysVisibleCount), alwaysVisibleCount + 1) : null}
    </div>
  );
};

export default Documents;
